import { useQuery } from 'react-query'
import api from '../services/api'

export const HUB_BRANDING_QUERY = 'hub-branding'

export const hubBrandingAPI = {
  get: () => api.get('/hub-branding'),
  update: (formData) =>
    api.put('/hub-branding', formData, {
      headers: { 'Content-Type': undefined }
    })
}

export function useHubBranding() {
  const query = useQuery(
    [HUB_BRANDING_QUERY],
    () => hubBrandingAPI.get().then((res) => res.data?.data || {}),
    {
      staleTime: 5 * 60 * 1000,
      refetchOnMount: true,
      retry: 1
    }
  )

  return {
    branding: query.data || {},
    isLoading: query.isLoading,
    ...query
  }
}
